/**
 * @generated SignedSource<<dfe59874ba06132d21dfd8e3048c89f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReferAFriend_referralsRef$data = {
  readonly referralHistory: {
    readonly currentMonth: {
      readonly successes: number;
    };
  };
  readonly referralLink: string | null;
  readonly " $fragmentType": "ReferAFriend_referralsRef";
};
export type ReferAFriend_referralsRef$key = {
  readonly " $data"?: ReferAFriend_referralsRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReferAFriend_referralsRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReferAFriend_referralsRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReferralHistory",
      "kind": "LinkedField",
      "name": "referralHistory",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReferralsStats",
          "kind": "LinkedField",
          "name": "currentMonth",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "successes",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralLink",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "5d6bc8fdef1241aa9517980ac3bca461";

export default node;
